import { ItemDataInput } from "../../models/item-data-models";
import { EndgameContent } from "../../models/enums";

export const itemData: ItemDataInput[] = [
  {
    "itemType": "Abyssal Eyes",
    "itemClass": "Augment",
    "currencySearchName": "Gaze",
    "imageBaseUrl": "/img/currency/abyssaleyesocketables/",
    "content": EndgameContent.Abyss,
    "isCurrency": true,
    "baseTypes": [
      "Amanamu's Gaze|amanamusgaze.webp",
      "Tecrod's Gaze|tecrodsgaze.webp",
      "Kurgal's Gaze|kurgalsgaze.webp",
      "Ulaman's Gaze|ulamansgaze.webp"
    ]
  },
  {
    "itemType": "Amulets",
    "itemClass": "Amulets",
    "currencySearchName": "Amulet",
    "imageBaseUrl": "/img/gear/amulets/",
    "isCurrency": false,
    "baseTypes": [
      "Crimson Amulet|crimsonamulet.webp",
      "Azure Amulet|azureamulet.webp",
      "Amber Amulet|amberamulet.webp",
      "Jade Amulet|jadeamulet.webp",
      "Lapis Amulet|lapisamulet.webp",
      "Lunar Amulet|lunaramulet.webp",
      "Bloodstone Amulet|bloodstoneamulet.webp",
      "Stellar Amulet|stellaramulet.webp",
      "Solar Amulet|solaramulet.webp",
      "Gold Amulet|goldamulet.webp",
      "Pearlescent Amulet|pearlescentamulet.webp",
      "Lament Amulet|lamentamulet.webp",
      "Portent Amulet|portentamulet.webp",
      "Absent Amulet|absentamulet.webp",
      "Corona Amulet|coronaamulet.webp",
      "Dusk Amulet|heistamulet1.webp",
      "Gloam Amulet|heistamulet1.webp",
      "Penumbra Amulet|heistamulet2.webp",
      "Tenebrous Amulet|heistamulet2.webp",
      "Twisted Amulet|twistedamulet.webp",
      "Distorted Amulet|distortedamulet.webp"
    ]
  },
  {
    "itemType": "Ancient Bones",
    "itemClass": "Stackable Currency",
    "currencySearchName": "\"Jawbone\" \"Rib\" \"Collarbone\" \"Cranium\"",
    "imageBaseUrl": "/img/currency/abyss/",
    "content": EndgameContent.Abyss,
    "isCurrency": true,
    "baseTypes": [
      "Gnawed Jawbone|gnawedjawbone.webp",
      "Preserved Jawbone|preservedjawbone.webp",
      "Ancient Jawbone|ancientjawbone.webp",
      "Gnawed Rib|gnawedribs.webp",
      "Preserved Rib|preservedribs.webp",
      "Ancient Rib|ancientribs.webp",
      "Gnawed Collarbone|gnawedclavicle.webp",
      "Preserved Collarbone|preservedcalvicle.webp",
      "Ancient Collarbone|ancientclavicle.webp",
      "Preserved Cranium|preservedcranium.webp",
      "Altered Collarbone|breachdesecration.webp"
    ]
  },
  {
    "itemType": "Belts",
    "itemClass": "Belts",
    "currencySearchName": "Belt",
    "imageBaseUrl": "/img/gear/belts/",
    "isCurrency": false,
    "baseTypes": [
      "Rawhide Belt|belt01.webp",
      "Linen Belt|belt02.webp",
      "Wide Belt|belt03.webp",
      "Long Belt|belt04.webp",
      "Plate Belt|belt05.webp",
      "Ornate Belt|belt06.webp",
      "Mail Belt|belt07.webp",
      "Double Belt|belt08.webp",
      "Heavy Belt|belt09.webp",
      "Utility Belt|belt10.webp",
      "Fine Belt|belt11.webp",
      "Stalking Belt|stalkingbelt.webp",
      "Invoking Belt|invokingbelt.webp",
      "Sinew Belt|sinewbelt.webp",
      "Forking Belt|forkingbelt.webp"
    ]
  },
  {
    "itemType": "Body Armours",
    "itemClass": "Body Armours",
    "currencySearchName": "Body Armour",
    "imageBaseUrl": "/img/gear/armours/bodyarmours/",
    "isCurrency": false,
    "isGear": true,
    "isArmour": true,
    "baseTypes": [
      "Rusted Cuirass|bodystr01.webp",
      "Fur Plate|bodystr02.webp",
      "Iron Cuirass|bodystr03.webp",
      "Raider Plate|bodystr04.webp",
      "Maraketh Cuirass|bodystr05.webp",
      "Steel Plate|bodystr06.webp",
      "Full Plate|bodystr07.webp",
      "Vaal Cuirass|bodystr08.webp",
      "Juggernaut Plate|bodystr09.webp",
      "Chieftain Cuirass|bodystr10.webp",
      "Leather Vest|bodydex01.webp",
      "Quilted Vest|bodydex02.webp",
      "Pathfinder Coat|bodydex03.webp",
      "Shrouded Vest|bodydex04.webp",
      "Rhoahide Coat|bodydex05.webp",
      "Studded Vest|bodydex06.webp",
      "Scout's Vest|bodydex07.webp",
      "Serpentscale Coat|bodydex08.webp",
      "Corsair Vest|bodydex09.webp",
      "Smuggler Coat|bodydex10.webp",
      "Tattered Robe|bodyint01.webp",
      "Feathered Robe|bodyint02.webp",
      "Hexer's Robe|bodyint03.webp",
      "Bone Raiment|bodyint04.webp",
      "Silk Robe|bodyint05.webp",
      "Keth Raiment|bodyint06.webp",
      "Votive Raiment|bodyint07.webp",
      "Altar Robe|bodyint08.webp",
      "Elementalist Robe|bodyint09.webp",
      "Mystic Raiment|bodyint10.webp",
      "Chain Mail|bodystrdex01.webp",
      "Rogue Armour|bodystrdex02.webp",
      "Vagabond Armour|bodystrdex03.webp",
      "Cloaked Mail|bodystrdex04.webp",
      "Explorer Armour|bodystrdex05.webp",
      "Scale Mail|bodystrdex06.webp",
      "Knight Armour|bodystrdex07.webp",
      "Ancestral Mail|bodystrdex08.webp",
      "Pilgrim Vestments|bodyintstr01.webp",
      "Pelt Mantle|bodyintstr02.webp",
      "Mail Vestments|bodyintstr03.webp",
      "Shaman Mantle|bodyintstr04.webp",
      "Ironclad Vestments|bodyintstr05.webp",
      "Sacrificial Mantle|bodyintstr06.webp",
      "Cleric Vestments|bodyintstr07.webp",
      "Tideseer Mantle|bodyintstr08.webp",
      "Hermit Garb|bodydexint01.webp",
      "Waxed Jacket|bodydexint02.webp",
      "Marabout Garb|bodydexint03.webp",
      "Wayfarer Jacket|bodydexint04.webp",
      "Anchorite Garb|bodydexint05.webp",
      "Scalper's Jacket|bodydexint06.webp",
      "Scoundrel Jacket|bodydexint07.webp",
      "Sacrificial Regalia|bodystrdexint02.webp",
      "Grasping Mail|bodystrdexint03.webp",
      "Elegant Plate|bodystr06.webp",
      "Heavy Plate|bodystr07.webp",
      "Stone Cuirass|bodystr08.webp",
      "Layered Vest|bodydex06.webp",
      "Runner Vest|bodydex07.webp",
      "Lizardscale Coat|bodydex08.webp",
      "River Raiment|bodyint06.webp",
      "Adherent's Raiment|bodyint07.webp",
      "Ceremonial Robe|bodyint08.webp",
      "Mantled Mail|bodystrdex04.webp",
      "Trailblazer Armour|bodystrdex05.webp",
      "Golden Mail|bodystrdex06.webp",
      "Occultist Mantle|bodyintstr04.webp",
      "Plated Vestments|bodyintstr05.webp",
      "Heartcarver Mantle|bodyintstr06.webp",
      "Itinerant Jacket|bodydexint04.webp",
      "Hatungo Garb|bodydexint05.webp",
      "Hawker's Jacket|bodydexint06.webp",
      "Soldier Cuirass|bodystr03.webp",
      "Ornate Plate|bodystr06.webp",
      "Utzaal Cuirass|bodystr08.webp",
      "Warlord Cuirass|bodystr10.webp",
      "Swiftstalker Coat|bodydex03.webp",
      "Slipstrike Vest|bodydex06.webp",
      "Wyrmscale Coat|bodydex08.webp",
      "Corsair Coat|bodydex10.webp",
      "Vile Robe|bodyint03.webp",
      "Flowing Raiment|bodyint06.webp",
      "Sacramental Robe|bodyint08.webp",
      "Feathered Raiment|bodyint10.webp",
      "Dastard Armour|bodystrdex02.webp",
      "Shrouded Mail|bodystrdex04.webp",
      "Death Mail|bodystrdex06.webp",
      "Thane Mail|bodystrdex08.webp",
      "Wolfskin Mantle|bodyintstr02.webp",
      "Conjurer Mantle|bodyintstr04.webp",
      "Death Mantle|bodyintstr06.webp",
      "Seastorm Mantle|bodyintstr08.webp",
      "Sleek Jacket|bodydexint02.webp",
      "Rambler Jacket|bodydexint04.webp",
      "Falconer's Jacket|bodydexint06.webp",
      "Austere Garb|bodydexint08.webp"
    ]
  },
  {
    "itemType": "Boots",
    "itemClass": "Boots",
    "currencySearchName": "Boots",
    "imageBaseUrl": "/img/gear/armours/boots/",
    "isCurrency": false,
    "isGear": true,
    "isArmour": true,
    "baseTypes": [
      "Rough Greaves|bootsstr01.webp",
      "Iron Greaves|bootsstr02.webp",
      "Bronze Greaves|bootsstr03.webp",
      "Trimmed Greaves|bootsstr04.webp",
      "Stone Greaves|bootsstr05.webp",
      "Reefsteel Greaves|bootsstr06.webp",
      "Rawhide Boots|bootsdex01.webp",
      "Laced Boots|bootsdex02.webp",
      "Embossed Boots|bootsdex03.webp",
      "Steeltoe Boots|bootsdex04.webp",
      "Lizardscale Boots|bootsdex05.webp",
      "Flared Boots|bootsdex06.webp",
      "Straw Sandals|bootsint01.webp",
      "Wrapped Sandals|bootsint02.webp",
      "Lattice Sandals|bootsint03.webp",
      "Silk Slippers|bootsint04.webp",
      "Feathered Sandals|bootsint05.webp",
      "Flax Sandals|bootsint06.webp",
      "Mail Sabatons|bootsstrdex01.webp",
      "Braced Sabatons|bootsstrdex02.webp",
      "Stacked Sabatons|bootsstrdex03.webp",
      "Covered Sabatons|bootsstrdex04.webp",
      "Padded Leggings|bootsintstr01.webp",
      "Secured Leggings|bootsintstr02.webp",
      "Pelt Leggings|bootsintstr03.webp",
      "Weaver Leggings|bootsintstr04.webp",
      "Frayed Shoes|bootsdexint01.webp",
      "Threaded Shoes|bootsdexint02.webp",
      "Hunting Shoes|bootsdexint03.webp",
      "Steelpoint Shoes|bootsdexint04.webp",
      "Elegant Greaves|bootsstr04.webp",
      "Carved Greaves|bootsstr05.webp",
      "Studded Boots|bootsdex04.webp",
      "Serpentscale Boots|bootsdex05.webp",
      "Elegant Slippers|bootsint04.webp",
      "Dunerunner Sandals|bootsint05.webp",
      "Bastion Sabatons|bootsstrdex03.webp",
      "Shamanistic Leggings|bootsintstr03.webp",
      "Treerunner Shoes|bootsdexint03.webp",
      "Bulwark Greaves|bootsstr02.webp",
      "Ornate Greaves|bootsstr04.webp",
      "Vaal Greaves|bootsstr05.webp",
      "Tasalian Greaves|bootsstr06.webp",
      "Cinched Boots|bootsdex02.webp",
      "Cavalry Boots|bootsdex04.webp",
      "Dragonscale Boots|bootsdex05.webp",
      "Drakeskin Boots|bootsdex06.webp",
      "Bound Sandals|bootsint02.webp",
      "Luxurious Slippers|bootsint04.webp",
      "Sandsworn Sandals|bootsint05.webp",
      "Sekhema Sandals|bootsint06.webp",
      "Veteran Sabatons|bootsstrdex01.webp",
      "Noble Sabatons|bootsstrdex02.webp",
      "Fortress Sabatons|bootsstrdex03.webp",
      "Blacksteel Sabatons|bootsstrdex04.webp",
      "Faithful Leggings|bootsintstr01.webp",
      "Apostle Leggings|bootsintstr02.webp",
      "Warlock Leggings|bootsintstr03.webp",
      "Cryptic Leggings|bootsintstr04.webp",
      "Wanderer Shoes|bootsdexint01.webp",
      "Charmed Shoes|bootsdexint02.webp",
      "Quickslip Shoes|bootsdexint03.webp",
      "Daggerfoot Shoes|bootsdexint04.webp"
    ]
  },
  {
    "itemType": "Bows",
    "itemClass": "Bows",
    "currencySearchName": "Bow",
    "imageBaseUrl": "/img/gear/weapons/twohandweapons/bows/",
    "isCurrency": false,
    "isGear": true,
    "isWeapon": true,
    "baseTypes": [
      "Crude Bow|bow01.webp",
      "Shortbow|bow02.webp",
      "Warden Bow|bow03.webp",
      "Recurve Bow|bow04.webp",
      "Composite Bow|bow05.webp",
      "Dualstring Bow|bow06.webp",
      "Cultist Bow|bow07.webp",
      "Zealot Bow|bow08.webp",
      "Artillery Bow|bow09.webp",
      "Tribal Bow|bow10.webp",
      "Twin Bow|bow06.webp",
      "Adherent Bow|bow07.webp",
      "Militant Bow|bow08.webp",
      "Ironwood Shortbow|bow02.webp",
      "Cavalry Bow|bow05.webp",
      "Guardian Bow|bow03.webp",
      "Gemini Bow|bow06.webp",
      "Fanatic Bow|bow07.webp",
      "Warmonger Bow|bow08.webp",
      "Obliterator Bow|bow09.webp"
    ]
  },
  {
    "itemType": "Bucklers",
    "itemClass": "Bucklers",
    "currencySearchName": "Buckler",
    "imageBaseUrl": "/img/gear/offhand/shields/",
    "isCurrency": false,
    "isGear": true,
    "isArmour": true,
    "isShield": true,
    "baseTypes": [
      "Leather Buckler|buckler01.webp",
      "Wooden Buckler|buckler02.webp",
      "Plated Buckler|buckler03.webp",
      "Iron Buckler|buckler04.webp",
      "Ridged Buckler|buckler05.webp",
      "Spiked Buckler|buckler06.webp",
      "Ringed Buckler|buckler07.webp",
      "Edged Buckler|buckler08.webp",
      "Laminate Buckler|buckler09.webp",
      "Pearl Buckler|buckler10.webp",
      "Ornate Buckler|buckler11.webp",
      "Spikeward Buckler|buckler06.webp",
      "Jingling Buckler|buckler07.webp",
      "Bladeguard Buckler|buckler08.webp",
      "Gutspike Buckler|buckler06.webp",
      "Ancient Buckler|buckler08.webp",
      "Desert Buckler|buckler09.webp"
    ]
  },
  {
    "itemType": "Catalysts",
    "tierListItemType": "Breach",
    "content": EndgameContent.Breach,
    "itemClass": "Stackable Currency",
    "currencySearchName": "Catalyst",
    "imageBaseUrl": "/img/currency/breach/",
    "isCurrency": true,
    "baseTypes": [
      "Flesh Catalyst|breachcatalystlife.webp",
      "Neural Catalyst|breachcatalystmana.webp",
      "Carapace Catalyst|breachcatalystdefences.webp",
      "Uul-Netol's Catalyst|breachcatalystphysical.webp",
      "Xoph's Catalyst|breachcatalystfire.webp",
      "Tul's Catalyst|breachcatalystcold.webp",
      "Esh's Catalyst|breachcatalystlightning.webp",
      "Chayula's Catalyst|breachcatalystchaos.webp",
      "Reaver Catalyst|breachcatalystattack.webp",
      "Sibilant Catalyst|breachcatalystcaster.webp",
      "Skittering Catalyst|breachcatalystspeed.webp",
      "Adaptive Catalyst|breachcatalystattribute.webp",
      "Refined Flesh Catalyst|jewelcatalystlife.webp",
      "Refined Neural Catalyst|jewelcatalystmana.webp",
      "Refined Carapace Catalyst|jewelcatalystdefences.webp",
      "Refined Uul-Netol's Catalyst|jewelcatalystphysical.webp",
      "Refined Xoph's Catalyst|jewelcatalystfire.webp",
      "Refined Tul's Catalyst|jewelcatalystcold.webp",
      "Refined Esh's Catalyst|jewelcatalystlightning.webp",
      "Refined Chayula's Catalyst|jewelcatalystchaos.webp",
      "Refined Reaver Catalyst|jewelcatalystattack.webp",
      "Refined Sibilant Catalyst|jewelcatalystcaster.webp",
      "Refined Skittering Catalyst|jewelcatalystspeed.webp",
      "Refined Adaptive Catalyst|jewelcatalystattribute.webp",
      "Necrotic Catalyst|breachcatalystnecrotic.webp",
      "Refined Necrotic Catalyst|jewelcatalystnecrotic.webp"
    ]
  },
  {
    "itemType": "Charms",
    "itemClass": "Charms",
    "currencySearchName": "Charm",
    "imageBaseUrl": "/img/gear/charms/",
    "isCurrency": false,
    "baseTypes": [
      "Thawing Charm|thawingcharm.webp",
      "Staunching Charm|staunchingcharm.webp",
      "Antidote Charm|antidotecharm.webp",
      "Dousing Charm|dousingcharm.webp",
      "Grounding Charm|groundingcharm.webp",
      "Stone Charm|stonecharm.webp",
      "Silver Charm|silvercharm.webp",
      "Ruby Charm|rubycharm.webp",
      "Sapphire Charm|sapphirecharm.webp",
      "Topaz Charm|topazcharm.webp",
      "Amethyst Charm|amethystcharm.webp",
      "Golden Charm|goldencharm.webp"
    ]
  },
  {
    "itemType": "Crossbows",
    "itemClass": "Crossbows",
    "currencySearchName": "Crossbow",
    "imageBaseUrl": "/img/gear/weapons/twohandweapons/crossbows/",
    "isCurrency": false,
    "isGear": true,
    "isWeapon": true,
    "baseTypes": [
      "Makeshift Crossbow|2hcrossbow01.webp",
      "Tense Crossbow|2hcrossbow02.webp",
      "Sturdy Crossbow|2hcrossbow03.webp",
      "Varnished Crossbow|2hcrossbow04.webp",
      "Dyad Crossbow|2hcrossbow05.webp",
      "Alloy Crossbow|2hcrossbow06.webp",
      "Bombard Crossbow|2hcrossbow07.webp",
      "Construct Crossbow|2hcrossbow08.webp",
      "Blackfire Crossbow|2hcrossbow09.webp",
      "Piercing Crossbow|2hcrossbow10.webp",
      "Twin Crossbow|2hcrossbow05.webp",
      "Cannonade Crossbow|2hcrossbow07.webp",
      "Bleak Crossbow|2hcrossbow08.webp",
      "Stout Crossbow|2hcrossbow03.webp",
      "Engraved Crossbow|2hcrossbow04.webp",
      "Flexed Crossbow|2hcrossbow02.webp",
      "Gemini Crossbow|2hcrossbow05.webp",
      "Siege Crossbow|2hcrossbow07.webp",
      "Desolate Crossbow|2hcrossbow08.webp",
      "Elegant Crossbow|2hcrossbow10.webp",
      "Trarthan Cannon|handcannon.webp"
    ]
  },
  {
    "itemType": "Currency",
    "itemClass": "Stackable Currency",
    "currencySearchName": "Stackable Currency",
    "imageBaseUrl": "",
    "isCurrency": true,
    "baseTypes": [
      "Blacksmith's Whetstone|/img/currency/currencyweaponquality.webp",
      "Arcanist's Etcher|/img/currency/currencyweaponmagicquality.webp",
      "Scroll of Wisdom|/img/currency/currencyidentification.webp",
      "Chaos Orb|/img/currency/currencyrerollrare.webp",
      "Greater Chaos Orb|/img/currency/currencyrerollrare.webp",
      "Perfect Chaos Orb|/img/currency/currencyrerollrare.webp",
      "Armourer's Scrap|/img/currency/currencyarmourquality.webp",
      "Mirror of Kalandra|/img/currency/currencyduplicate.webp",
      "Hinekora's Lock|/img/currency/hinekoraslock.webp",
      "Orb of Alchemy|/img/currency/currencyupgradetorare.webp",
      "Orb of Chance|/img/currency/currencyupgradetounique.webp",
      "Orb of Transmutation|/img/currency/currencyupgradetomagic.webp",
      "Greater Orb of Transmutation|/img/currency/currencyupgradetomagic.webp",
      "Perfect Orb of Transmutation|/img/currency/currencyupgradetomagic.webp",
      "Exalted Orb|/img/currency/currencyaddmodtorare.webp",
      "Greater Exalted Orb|/img/currency/currencyaddmodtorare.webp",
      "Perfect Exalted Orb|/img/currency/currencyaddmodtorare.webp",
      "Regal Orb|/img/currency/currencyupgrademagictorare.webp",
      "Greater Regal Orb|/img/currency/currencyupgrademagictorare.webp",
      "Perfect Regal Orb|/img/currency/currencyupgrademagictorare.webp",
      "Orb of Augmentation|/img/currency/currencyaddmodtomagic.webp",
      "Greater Orb of Augmentation|/img/currency/currencyaddmodtomagic.webp",
      "Perfect Orb of Augmentation|/img/currency/currencyaddmodtomagic.webp",
      "Glassblower's Bauble|/img/currency/currencyflaskquality.webp",
      "Gemcutter's Prism|/img/currency/currencygemquality.webp",
      "Lesser Jeweller's Orb|/img/currency/currencyrerollsocketnumbers01.webp",
      "Greater Jeweller's Orb|/img/currency/currencyrerollsocketnumbers02.webp",
      "Perfect Jeweller's Orb|/img/currency/currencyrerollsocketnumbers03.webp",
      "Artificer's Orb|/img/currency/currencyaddequipmentsocket.webp",
      "Divine Orb|/img/currency/currencymodvalues.webp",
      "Transmutation Shard|/img/currency/currencyupgradetomagicshard.webp",
      "Chance Shard|/img/currency/currencyupgradetouniqueshard.webp",
      "Albino Rhoa Feather|/img/currency/currencyrhoafeather.webp",
      "Vaal Orb|/img/currency/currencyvaal.webp",
      "Architect's Orb|/img/currency/incursioncraftingorbs/incursiongreatervaalorb.webp",
      "Crystallised Corruption|/img/currency/incursioncraftingorbs/incursioncrystallisedcorruption.webp",
      "Core Destabiliser|/img/currency/incursioncraftingorbs/incursioncoredestabliser.webp",
      "Ancient Infuser|/img/currency/incursioncraftingorbs/incursionancientinfusion.webp",
      "Vaal Cultivation Orb|/img/currency/incursioncraftingorbs/incursionhistoricvaalorb.webp",
      "Yaomac's Orb of Sacrifice|/img/currency/incursioncraftingorbs/incursioncorruptionorb1.webp",
      "Kopec's Orb of Sacrifice|/img/currency/incursioncraftingorbs/incursioncorruptionorb2.webp",
      "Kamasa's Orb of Sacrifice|/img/currency/incursioncraftingorbs/incursioncorruptionorb3.webp",
      "Yugul's Orb of Sacrifice|/img/currency/incursioncraftingorbs/incursioncorruptionorb4.webp",
      "Vaal Armourer's Infuser|/img/currency/incursioncraftingorbs/vaakarmourersscrap.webp",
      "Vaal Blacksmith's Infuser|/img/currency/incursioncraftingorbs/vaalblacksmithswhetstone.webp",
      "Vaal Arcanist's Infuser|/img/currency/incursioncraftingorbs/vaalarcanistsetcher.webp",
      "Vaal Catalysing Infuser|/img/currency/incursioncraftingorbs/vaalcatalyst.webp",
      "Orb of Extraction|/img/currency/incursioncraftingorbs/incursionsocketableextractorcurrency.webp",
      "Orb of Annulment|/img/currency/annullorb.webp",
      "Fracturing Orb|/img/currency/fracturingorb.webp",
      "Regal Shard|/img/currency/currencyupgrademagictorareshard.webp",
      "Artificer's Shard|/img/currency/currencyaddequipmentsocketshard.webp",
      "Shattered Triskelion|/img/currency/damagedkalguurantriskellion.webp",
      "Exceptional Verisium|/img/currency/PerfectVerisium.webp",
      "Medved's Crest of the Circle|/img/currency/UhtredCrest.webp",
      "Vorana's Crest of the Scythe|/img/currency/VoranaCrest.webp",
      "Uhtred's Crest of the Chalice|/img/currency/MedvedCrest.webp",
      "Olroth's Crest of the Sun|/img/currency/OlrothCrest.webp",
      "Cryptic Key|/img/currency/StrongboxSkeletonKey.webp",
    ]
  },
  {
    "itemType": "Essences",
    "itemClass": "Stackable Currency",
    "currencySearchName": "Essence",
    "imageBaseUrl": "/img/currency/essence/",
    "content": EndgameContent.Essence,
    "isCurrency": true,
    "baseTypes": [
      "Lesser Essence of the Body|lifeessencelesser.webp",
      "Lesser Essence of the Mind|manaessencelesser.webp",
      "Lesser Essence of Enhancement|defencesessencelesser.webp",
      "Lesser Essence of Abrasion|physicalessencelesser.webp",
      "Lesser Essence of Flames|fireessencelesser.webp",
      "Lesser Essence of Ice|coldessencelesser.webp",
      "Lesser Essence of Electricity|lightningessencelesser.webp",
      "Lesser Essence of Ruin|chaosessencelesser.webp",
      "Lesser Essence of Battle|attackessencelesser.webp",
      "Lesser Essence of Sorcery|casteressencelesser.webp",
      "Lesser Essence of Haste|speedessencelesser.webp",
      "Lesser Essence of the Infinite|attributeessencelesser.webp",
      "Essence of the Body|lifeessence.webp",
      "Essence of the Mind|manaessence.webp",
      "Essence of Enhancement|defencesessence.webp",
      "Essence of Abrasion|physicalessence.webp",
      "Essence of Flames|fireessence.webp",
      "Essence of Ice|coldessence.webp",
      "Essence of Electricity|lightningessence.webp",
      "Essence of Ruin|chaosessence.webp",
      "Essence of Battle|attackessence.webp",
      "Essence of Sorcery|casteressence.webp",
      "Essence of Haste|speedessence.webp",
      "Essence of the Infinite|attributeessence.webp",
      "Greater Essence of the Body|greaterlifeessence.webp",
      "Greater Essence of the Mind|greatermanaessence.webp",
      "Greater Essence of Enhancement|greaterdefencesessence.webp",
      "Greater Essence of Abrasion|greaterphysicalessence.webp",
      "Greater Essence of Flames|greaterfireessence.webp",
      "Greater Essence of Ice|greatercoldessence.webp",
      "Greater Essence of Electricity|greaterlightningessence.webp",
      "Greater Essence of Ruin|greaterchaosessence.webp",
      "Greater Essence of Battle|greaterattackessence.webp",
      "Greater Essence of Sorcery|greatercasteressence.webp",
      "Greater Essence of Haste|greaterspeedessence.webp",
      "Greater Essence of the Infinite|greaterattributeessence.webp",
      "Perfect Essence of the Body|lifeessenceperfect.webp",
      "Perfect Essence of the Mind|manaessenceperfect.webp",
      "Perfect Essence of Enhancement|defencesessenceperfect.webp",
      "Perfect Essence of Abrasion|physicalessenceperfect.webp",
      "Perfect Essence of Flames|fireessenceperfect.webp",
      "Perfect Essence of Ice|coldessenceperfect.webp",
      "Perfect Essence of Electricity|lightningessenceperfect.webp",
      "Perfect Essence of Ruin|chaosessenceperfect.webp",
      "Perfect Essence of Battle|attackessenceperfect.webp",
      "Perfect Essence of Sorcery|casteressenceperfect.webp",
      "Perfect Essence of Haste|speedessenceperfect.webp",
      "Perfect Essence of the Infinite|attributeessenceperfect.webp",
      "Lesser Essence of Seeking|criticalessencelesser.webp",
      "Essence of Seeking|criticalessence.webp",
      "Greater Essence of Seeking|greatercriticalessence.webp",
      "Perfect Essence of Seeking|criticalessenceperfect.webp",
      "Essence of Hysteria|corruptedessencehysteria.webp",
      "Essence of Delirium|corruptedessencedelirium.webp",
      "Essence of Horror|corruptedessencehorror.webp",
      "Essence of Insanity|corruptedessenceinsanity.webp",
      "Essence of the Abyss|abyssalessence.webp",
      "Essence of the Breach|breachessence.webp",
      "Lesser Essence of Insulation|fireresistanceessencelesser.webp",
      "Essence of Insulation|fireresistanceessence.webp",
      "Greater Essence of Insulation|greaterfireresistanceessence.webp",
      "Perfect Essence of Insulation|fireresistanceessenceperfect.webp",
      "Lesser Essence of Thawing|coldresistanceessencelesser.webp",
      "Essence of Thawing|coldresistanceessence.webp",
      "Greater Essence of Thawing|greatercoldresistanceessence.webp",
      "Perfect Essence of Thawing|coldresistanceessenceperfect.webp",
      "Lesser Essence of Grounding|lightningresistanceessencelesser.webp",
      "Essence of Grounding|lightningresistanceessence.webp",
      "Greater Essence of Grounding|greaterlightningresistanceessence.webp",
      "Perfect Essence of Grounding|lightningresistanceessenceperfect.webp",
      "Lesser Essence of Alacrity|speedcasteressencelesser.webp",
      "Essence of Alacrity|speedcasteressence.webp",
      "Greater Essence of Alacrity|greaterspeedcasteressence.webp",
      "Perfect Essence of Alacrity|speedcasteressenceperfect.webp",
      "Lesser Essence of Opulence|rarityresistanceessencelesser.webp",
      "Essence of Opulence|rarityresistanceessence.webp",
      "Greater Essence of Opulence|greaterrarityresistanceessence.webp",
      "Perfect Essence of Opulence|rarityresistanceessenceperfect.webp",
      "Lesser Essence of Command|allyessencelesser.webp",
      "Essence of Command|allyessence.webp",
      "Greater Essence of Command|greaterallyessence.webp",
      "Perfect Essence of Command|allyessenceperfect.webp"
    ]
  },
  {
    "itemType": "Foci",
    "itemClass": "Foci",
    "currencySearchName": "Focus",
    "imageBaseUrl": "/img/gear/offhand/foci/",
    "isCurrency": false,
    "isGear": true,
    "isArmour": true,
    "baseTypes": [
      "Twig Focus|focus01.webp",
      "Woven Focus|focus02.webp",
      "Antler Focus|focus03.webp",
      "Engraved Focus|focus04.webp",
      "Tonal Focus|focus05.webp",
      "Crystal Focus|focus06.webp",
      "Voodoo Focus|focus07.webp",
      "Plumed Focus|focus08.webp",
      "Runed Focus|focus09.webp",
      "Whorl Focus|focus10.webp",
      "Arrayed Focus|focus06.webp",
      "Cultist Focus|focus07.webp",
      "Hallowed Focus|focus08.webp",
      "Druidic Focus|focus03.webp",
      "Leyline Focus|focus06.webp",
      "Sacred Focus|focus08.webp",
      "Tasalian Focus|focus10.webp"
    ]
  },
  {
    "itemType": "Gloves",
    "itemClass": "Gloves",
    "currencySearchName": "Gloves",
    "imageBaseUrl": "/img/gear/armours/gloves/",
    "isCurrency": false,
    "isGear": true,
    "isArmour": true,
    "baseTypes": [
      "Stocky Mitts|glovesstr01.webp",
      "Riveted Mitts|glovesstr02.webp",
      "Tempered Mitts|glovesstr03.webp",
      "Bolstered Mitts|glovesstr04.webp",
      "Moulded Mitts|glovesstr05.webp",
      "Detailed Mitts|glovesstr06.webp",
      "Suede Bracers|glovesdex01.webp",
      "Firm Bracers|glovesdex02.webp",
      "Bound Bracers|glovesdex03.webp",
      "Sectioned Bracers|glovesdex04.webp",
      "Spined Bracers|glovesdex05.webp",
      "Fine Bracers|glovesdex06.webp",
      "Torn Gloves|glovesint01.webp",
      "Sombre Gloves|glovesint02.webp",
      "Stitched Gloves|glovesint03.webp",
      "Jewelled Gloves|glovesint04.webp",
      "Intricate Gloves|glovesint05.webp",
      "Pauascale Gloves|glovesint06.webp",
      "Ringmail Gauntlets|glovesstrdex01.webp",
      "Layered Gauntlets|glovesstrdex02.webp",
      "Doubled Gauntlets|glovesstrdex03.webp",
      "Plate Gauntlets|glovesstrdex04.webp",
      "Rope Cuffs|glovesintstr01.webp",
      "Aged Cuffs|glovesintstr02.webp",
      "Goldcast Cuffs|glovesintstr03.webp",
      "Kalguuran Cuffs|glovesintstr04.webp",
      "Righteous Cuffs|glovesintstr05png.webp",
      "Gauze Wraps|glovesdexint01.webp",
      "Linen Wraps|glovesdexint02.webp",
      "Spiral Wraps|glovesdexint03.webp",
      "Buckled Wraps|glovesdexint04.webp",
      "Ancient Mitts|glovesstr04.webp",
      "Feathered Mitts|glovesstr05.webp",
      "Refined Bracers|glovesdex04.webp",
      "Spiked Bracers|glovesdex05.webp",
      "Baroque Gloves|glovesint04.webp",
      "Gold Gloves|glovesint05.webp",
      "Zealot Gauntlets|glovesstrdex03.webp",
      "Ornate Cuffs|glovesintstr03.webp",
      "Adorned Wraps|glovesdexint03.webp",
      "Knightly Mitts|glovesstr02.webp",
      "Ornate Mitts|glovesstr04.webp",
      "Vaal Mitts|glovesstr05.webp",
      "Massive Mitts|glovesstr06.webp",
      "Stalking Bracers|glovesdex02.webp",
      "Grand Bracers|glovesdex04.webp",
      "Barbed Bracers|glovesdex05.webp",
      "Polished Bracers|glovesdex06.webp",
      "Grim Gloves|glovesint02.webp",
      "Opulent Gloves|glovesint04.webp",
      "Vaal Gloves|glovesint05.webp",
      "Sirenscale Gloves|glovesint06.webp",
      "Steelmail Gauntlets|glovesstrdex01.webp",
      "Commander Gauntlets|glovesstrdex02.webp",
      "Cultist Gauntlets|glovesstrdex03.webp",
      "Blacksteel Gauntlets|glovesstrdex04.webp",
      "Bound Cuffs|glovesintstr01.webp",
      "Ancient Cuffs|glovesintstr02.webp",
      "Gleaming Cuffs|glovesintstr03.webp",
      "Adherent Cuffs|glovesintstr04.webp",
      "War Wraps|glovesdexint01.webp",
      "Elegant Wraps|glovesdexint02.webp",
      "Vaal Wraps|glovesdexint03.webp",
      "Secured Wraps|glovesdexint04.webp"
    ]
  },
  {
    "itemType": "Helmets",
    "itemClass": "Helmets",
    "currencySearchName": "Helmet",
    "imageBaseUrl": "/img/gear/armours/helmets/",
    "isCurrency": false,
    "isGear": true,
    "isArmour": true,
    "baseTypes": [
      "Rusted Greathelm|helmetstr01.webp",
      "Soldier Greathelm|helmetstr02.webp",
      "Wrapped Greathelm|helmetstr03.webp",
      "Spired Greathelm|helmetstr04.webp",
      "Elite Greathelm|helmetstr05.webp",
      "Warrior Greathelm|helmetstr06.webp",
      "Commander Greathelm|helmetstr07.webp",
      "Fierce Greathelm|helmetstr08.webp",
      "Shabby Hood|helmetdex01.webp",
      "Felt Cap|helmetdex02.webp",
      "Lace Hood|helmetdex03.webp",
      "Swathed Cap|helmetdex04.webp",
      "Hunter Hood|helmetdex05.webp",
      "Viper Cap|helmetdex06.webp",
      "Corsair Cap|helmetdex07.webp",
      "Leatherbound Hood|helmetdex08.webp",
      "Twig Circlet|helmetint01.webp",
      "Wicker Tiara|helmetint02.webp",
      "Beaded Circlet|helmetint03.webp",
      "Chain Tiara|helmetint04.webp",
      "Feathered Tiara|helmetint05.webp",
      "Gold Circlet|helmetint06.webp",
      "Vermeil Circlet|helmetint07.webp",
      "Jade Tiara|helmetint08.webp",
      "Brimmed Helm|helmetstrdex01.webp",
      "Guarded Helm|helmetstrdex02.webp",
      "Visored Helm|helmetstrdex03.webp",
      "Cowled Helm|helmetstrdex04.webp",
      "Shielded Helm|helmetstrdex05.webp",
      "Closed Helm|helmetstrdex06.webp",
      "Iron Crown|helmetintstr01.webp",
      "Horned Crown|helmetintstr02.webp",
      "Cultist Crown|helmetintstr03.webp",
      "Martyr Crown|helmetintstr04.webp",
      "Heavy Crown|helmetintstr05.webp",
      "Spiritbone Crown|helmetintstr06.webp",
      "Hewn Mask|helmetdexint01.webp",
      "Face Mask|helmetdexint02.webp",
      "Hooded Mask|helmetdexint03.webp",
      "Veiled Mask|helmetdexint04.webp",
      "Tribal Mask|helmetdexint05.webp",
      "Solid Mask|helmetdexint06.webp",
      "Elegant Greathelm|helmetstr04.webp",
      "Noble Greathelm|helmetstr05.webp",
      "Wrapped Cap|helmetdex04.webp",
      "Deerstalker Hood|helmetdex05.webp",
      "Sandsworn Tiara|helmetint04.webp",
      "Jungle Tiara|helmetint05.webp",
      "Cabalist Helm|helmetstrdex04.webp",
      "Cassis Helm|helmetstrdex05.webp",
      "Hallowed Crown|helmetintstr04.webp",
      "Inquisitor Crown|helmetintstr05.webp",
      "Pariah Mask|helmetdexint04.webp",
      "Avian Mask|helmetdexint05.webp",
      "Warmonger Greathelm|helmetstr02.webp",
      "Masked Greathelm|helmetstr04.webp",
      "Paragon Greathelm|helmetstr05.webp",
      "Imperial Greathelm|helmetstr07.webp",
      "Woven Cap|helmetdex02.webp",
      "Desert Cap|helmetdex04.webp",
      "Trapper Hood|helmetdex05.webp",
      "Freebooter Cap|helmetdex07.webp",
      "Skycrown Tiara|helmetint02.webp",
      "Sorcerous Tiara|helmetint04.webp",
      "Kamasan Tiara|helmetint05.webp",
      "Ancestral Tiara|helmetint08.webp",
      "Warded Helm|helmetstrdex02.webp",
      "Cryptic Helm|helmetstrdex04.webp",
      "Champion Helm|helmetstrdex05.webp",
      "Gladiatorial Helm|helmetstrdex06.webp",
      "Druidic Crown|helmetintstr02.webp",
      "Saintly Crown|helmetintstr04.webp",
      "Divine Crown|helmetintstr05.webp",
      "Cryptic Crown|helmetintstr06.webp",
      "Brigand Mask|helmetdexint02.webp",
      "Faridun Mask|helmetdexint04.webp",
      "Soaring Mask|helmetdexint05.webp",
      "Grinning Mask|helmetdexint06.webp"
    ]
  },
  {
    "itemType": "Idols",
    "itemClass": "Augment",
    "currencySearchName": "Idol",
    "imageBaseUrl": "/img/currency/tormentedspiritsocketables/",
    "isCurrency": true,
    "content": EndgameContent.AzmeriSpirit,
    "baseTypes": [
      "Idol of Sirrius|azmerisocketablewolfspecial.webp",
      "Idol of Thruldana|azmerisocketablesnakespecial.webp",
      "Idol of Grold|azmerisocketablebearspecial.webp",
      "Idol of Eeshta|azmerisocketableowlspecial.webp",
      "Idol of Egrin|azmerisocketablecatspecial.webp",
      "Idol of Maxarius|azmerisocketablestagspecial.webp",
      "Idol of Ralakesh|azmerisocketablemonkeyspecial.webp",
      "Idol of Greust|idolofgreust.webp",
      "Idol of Yeena|idolofyeena.webp",
      "Idol of Eramir|idoloferamir.webp",
      "Idol of Oak|idolofoak.webp",
      "Idol of Alira|idoloalira.webp",
      "Idol of Kraityn|idolokraityn.webp",
      "Idol of Silk|idolofsilk.webp",
      "Idol of the Sycophant|ritualcorruptedidol1.webp",
      "Idol of the Martyr|ritualcorruptedidol2.webp",
      "Idol of the Pharisee|ritualcorruptedidol3.webp",
      "Panther Idol|azmerisocketablepanther.webp",
      "Hawk Idol|azmerisocketablehawk.webp",
      "Stoat Idol|azmerisocketablestoat.webp",
      "Snake Idol|azmerisocketablesnake.webp",
      "Primate Idol|azmerisocketablemonkey.webp",
      "Owl Idol|azmerisocketableowl.webp",
      "Cat Idol|azmerisocketablecat.webp",
      "Wolf Idol|azmerisocketablewolf.webp",
      "Stag Idol|azmerisocketablestag.webp",
      "Boar Idol|azmerisocketableboar.webp",
      "Bear Idol|azmerisocketablebear.webp",
      "Ox Idol|azmerisocketableox.webp",
      "Rabbit Idol|azmerisocketablerabbit.webp",
      "Fox Idol|azmerisocketablefox.webp"
    ]
  },
  {
    "itemType": "Jewels",
    "itemClass": "Jewels",
    "currencySearchName": "Jewel",
    "imageBaseUrl": "/img/gear/jewels/",
    "isCurrency": false,
    "baseTypes": [
      "Timeless Jewel|timeless.webp",
      "Ruby|rubyjewel.webp",
      "Emerald|emeraldjewel.webp",
      "Sapphire|sapphirejewel.webp",
      "Diamond|diamondjewel.webp",
      "Time-Lost Ruby|specialrubyjewel.webp",
      "Time-Lost Emerald|specialemeraldjewel.webp",
      "Time-Lost Sapphire|specialsapphirejewel.webp",
      "Time-Lost Diamond|timelostdiamondjewel.webp"
    ]
  },
  {
    "itemType": "Life Flasks",
    "itemClass": "Life Flasks",
    "currencySearchName": "Life Flask",
    "imageBaseUrl": "/img/gear/flasks/",
    "isCurrency": false,
    "baseTypes": [
      "Lesser Life Flask|flasklife01.webp",
      "Medium Life Flask|flasklife02.webp",
      "Greater Life Flask|flasklife03.webp",
      "Grand Life Flask|flasklife04.webp",
      "Giant Life Flask|flasklife05.webp",
      "Colossal Life Flask|flasklife06.webp",
      "Gargantuan Life Flask|flasklife07.webp",
      "Transcendent Life Flask|flasklife08.webp",
      "Ultimate Life Flask|flasklife09.webp"
    ]
  },
  {
    "itemType": "Liquid Emotions",
    "tierListItemType": "Delirium",
    "content": EndgameContent.Delirium,
    "itemClass": "Stackable Currency",
    "currencySearchName": "Liquid",
    "imageBaseUrl": "/img/currency/distilledemotions/",
    "isCurrency": true,
    "baseTypes": [
      "Diluted Liquid Ire|diluteddistilledire.webp",
      "Diluted Liquid Guilt|diluteddistilledguilt.webp",
      "Diluted Liquid Greed|diluteddistilledgreed.webp",
      "Liquid Paranoia|distilledparanoia.webp",
      "Liquid Envy|distilledenvy.webp",
      "Liquid Disgust|distilleddisgust.webp",
      "Liquid Despair|distilleddespair.webp",
      "Concentrated Liquid Fear|concentrateddistilledfear.webp",
      "Concentrated Liquid Suffering|concentrateddistilledsuffering.webp",
      "Concentrated Liquid Isolation|concentrateddistilledisolation.webp",
      "Ancient Diluted Liquid Ire|timelostdiluteddistilledire.webp",
      "Ancient Diluted Liquid Guilt|timelostdiluteddistilledguilt.webp",
      "Ancient Diluted Liquid Greed|timelostdiluteddistilledgreed.webp",
      "Ancient Liquid Paranoia|timelostdistilledparanoia.webp",
      "Ancient Liquid Envy|timelostdistilledenvy.webp",
      "Ancient Liquid Disgust|timelostdistilleddisgust.webp",
      "Ancient Liquid Despair|timelostdistilleddespair.webp",
      "Ancient Concentrated Liquid Fear|timelostconcentrateddistilledfear.webp",
      "Ancient Concentrated Liquid Suffering|timelostconcentrateddistilledsuffering.webp",
      "Ancient Concentrated Liquid Isolation|timelostconcentrateddistilledisolation.webp",
      "Potent Liquid Melancholy|uniquehumansemotion.webp",
      "Potent Liquid Ferocity|uniqueconstructsemotion.webp",
      "Potent Liquid Contempt|uniquebeastemotion.webp",
      "Ancient Potent Liquid Melancholy|timelessuniquehumansemotion.webp",
      "Ancient Potent Liquid Ferocity|timlessuniqueconstructsemotion.webp",
      "Ancient Potent Liquid Contempt|timelessuniquebeastemotion.webp"
    ]
  },
  {
    "itemType": "Mana Flasks",
    "itemClass": "Mana Flasks",
    "currencySearchName": "Mana Flask",
    "imageBaseUrl": "/img/gear/flasks/",
    "isCurrency": false,
    "baseTypes": [
      "Lesser Mana Flask|flaskmana01.webp",
      "Medium Mana Flask|flaskmana02.webp",
      "Greater Mana Flask|flaskmana03.webp",
      "Grand Mana Flask|flaskmana04.webp",
      "Giant Mana Flask|flaskmana05.webp",
      "Colossal Mana Flask|flaskmana06.webp",
      "Gargantuan Mana Flask|flaskmana07.webp",
      "Transcendent Mana Flask|flaskmana08.webp",
      "Ultimate Mana Flask|flaskmana09.webp"
    ]
  },
  {
    "itemType": "Omens",
    "itemClass": "Omen",
    "currencySearchName": "Omen",
    "imageBaseUrl": "/img/currency/omens/",
    "isCurrency": true,
    "content": EndgameContent.Ritual,
    "baseTypes": [
      "Aldur's Saga|specialexpeditionpage5.webp",
      "Medved's Saga|specialexpeditionpage3.webp",
      "Vorana's Saga|specialexpeditionpage2.webp",
      "Uhtred's Saga|specialexpeditionpage4.webp",
      "Olroth's Saga|specialexpeditionpage1.webp",
      "Omen of Refreshment|voodooomens1blue.webp",
      "Omen of Resurgence|voodooomens2blue.webp",
      "Omen of Amelioration|voodooomens3blue.webp",
      "Omen of Whittling|voodooomens1dark.webp",
      "Omen of Sinistral Erasure|voodooomens2dark.webp",
      "Omen of Dextral Erasure|voodooomens3dark.webp",
      "Omen of Greater Exaltation|voodooomens1yellow.webp",
      "Omen of Sinistral Exaltation|voodooomens2yellow.webp",
      "Omen of Dextral Exaltation|voodooomens3yellow.webp",
      "Omen of Sinistral Annulment|voodooomens2purple.webp",
      "Omen of Dextral Annulment|voodooomens3purple.webp",
      "Omen of Answered Prayers|voodooomens4blue.webp",
      "Omen of Secret Compartments|voodooomens4dark.webp",
      "Omen of the Hunt|voodooomens4green.webp",
      "Omen of Reinforcements|voodooomens4purple.webp",
      "Omen of Gambling|omengamblenogoldcost.webp",
      "Omen of Bartering|omensellvendorrandomise.webp",
      "Omen of the Blessed|omenondivinererollimplicits.webp",
      "Omen of Chaotic Rarity|omenonchaosmapitemrarity.webp",
      "Omen of Chaotic Quantity|omenonchaosmappacksize.webp",
      "Omen of Chaotic Monsters|omenonchaosmapitemquantity.webp",
      "Omen of Chaotic Effectiveness|omenonchaosmapmonstereffectiveness.webp",
      "Omen of Chance|omenonchancenotdestroy.webp",
      "Omen of the Ancients|omenonchanceancientorb.webp",
      "Omen of Sanctification|omenondivinesanctify.webp",
      "Omen of Dextral Crystallisation|omenonperfectessencesuffix.webp",
      "Omen of Sinistral Crystallisation|omenonperfectessenceprefix.webp",
      "Omen of Catalysing Exaltation|omenonexaltconsumequality.webp",
      "Omen of Abyssal Echoes|omenonabyssrerolloptions.webp",
      "Omen of the Sovereign|omenonabyssguarenteedlichtypemod1.webp",
      "Omen of the Liege|omenonabyssguarenteedlichtypemod2.webp",
      "Omen of the Blackblooded|omenonabyssguarenteedlichtypemod3.webp",
      "Omen of Putrefaction|omenonabyssveilallandcorrupt.webp",
      "Omen of Light|omenonannulremoveabyssmod.webp",
      "Omen of Sinistral Necromancy|omenonabyssaddprefixes.webp",
      "Omen of Dextral Necromancy|omenonabyssaddsuffixes.webp"
    ]
  },
  {
    "itemType": "One Hand Maces",
    "itemClass": "One Hand Maces",
    "currencySearchName": "One Hand Mace",
    "imageBaseUrl": "/img/gear/weapons/onehandweapons/onehandmaces/",
    "isCurrency": false,
    "isGear": true,
    "isWeapon": true,
    "baseTypes": [
      "Wooden Club|1hmace01.webp",
      "Smithing Hammer|1hmace02.webp",
      "Slim Mace|1hmace03.webp",
      "Spiked Club|1hmace04.webp",
      "Warpick|1hmace05.webp",
      "Plated Mace|1hmace06.webp",
      "Brigand Mace|1hmace07.webp",
      "Construct Hammer|1hmace08.webp",
      "Morning Star|1hmace09.webp",
      "Jade Club|1hmace10.webp",
      "Kalguuran Forgehammer|1hmace01.webp",
      "Marching Mace|1hmace06.webp",
      "Bandit Mace|1hmace07.webp",
      "Structured Hammer|1hmace08.webp",
      "Flanged Mace|1hmace03.webp",
      "Crown Mace|1hmace06.webp",
      "Molten Hammer|1hmace02.webp",
      "Strife Pick|1hmace05.webp",
      "Fortified Hammer|1hmace08.webp",
      "Marauding Mace|1hmace07.webp",
      "Akoyan Club|1hmace10.webp"
    ]
  },
  {
    "itemType": "Quarterstaves",
    "itemClass": "Quarterstaves",
    "currencySearchName": "Quarterstaff",
    "imageBaseUrl": "/img/gear/weapons/twohandweapons/warstaves/",
    "isCurrency": false,
    "isGear": true,
    "isWeapon": true,
    "baseTypes": [
      "Wrapped Quarterstaff|warstaff01.webp",
      "Long Quarterstaff|warstaff02.webp",
      "Gothic Quarterstaff|warstaff03.webp",
      "Crackling Quarterstaff|warstaff04.webp",
      "Crescent Quarterstaff|warstaff05.webp",
      "Steelpoint Quarterstaff|warstaff06.webp",
      "Slicing Quarterstaff|warstaff07.webp",
      "Barrier Quarterstaff|warstaff08.webp",
      "Hefty Quarterstaff|warstaff09.webp",
      "Smooth Quarterstaff|warstaff10.webp",
      "Waxing Quarterstaff|warstaff05.webp",
      "Bladed Quarterstaff|warstaff07.webp",
      "Guardian Quarterstaff|warstaff08.webp",
      "Sinister Quarterstaff|warstaff03.webp",
      "Lunar Quarterstaff|warstaff05.webp",
      "Striking Quarterstaff|warstaff02.webp",
      "Bolting Quarterstaff|warstaff04.webp",
      "Aegis Quarterstaff|warstaff08.webp",
      "Razor Quarterstaff|warstaff07.webp",
      "Skullcrusher Quarterstaff|warstaff09.webp",
      "Dreaming Quarterstaff|warstaff10.webp"
    ]
  },
  {
    "itemType": "Quivers",
    "itemClass": "Quivers",
    "currencySearchName": "Quiver",
    "imageBaseUrl": "/img/gear/quivers/",
    "isCurrency": false,
    "isGear": true,
    "isWeapon": true,
    "baseTypes": [
      "Broadhead Quiver|quiverbroadhead.webp",
      "Fire Quiver|quiverfire.webp",
      "Sacral Quiver|quiversacral.webp",
      "Two-Point Quiver|quivertwopoint.webp",
      "Blunt Quiver|quiverblunt.webp",
      "Toxic Quiver|quivertoxic.webp",
      "Serrated Quiver|quiverserrated.webp",
      "Primed Quiver|quiverprimed.webp",
      "Penetrating Quiver|quiverpenetrating.webp",
      "Volant Quiver|quivervolant.webp",
      "Visceral Quiver|quivervisceral.webp"
    ]
  },
  {
    "itemType": "Relics",
    "itemClass": "Relics",
    "currencySearchName": "Relic",
    "imageBaseUrl": "/img/gear/relics/",
    "content": EndgameContent.SekhemasTrial,
    "isCurrency": false,
    "baseTypes": [
      "Urn Relic|relicbase1x2.webp",
      "Amphora Relic|relicbase1x3.webp",
      "Vase Relic|relicbase1x4.webp",
      "Seal Relic|relicbase2x1.webp",
      "Coffer Relic|relicbase2x2.webp",
      "Tapestry Relic|relicbase3x1.webp",
      "Incense Relic|relicbase4x1.webp"
    ]
  },
  {
    "itemType": "Rings",
    "itemClass": "Rings",
    "currencySearchName": "Ring",
    "imageBaseUrl": "/img/gear/rings/",
    "isCurrency": false,
    "baseTypes": [
      "Iron Ring|ironring.webp",
      "Lazuli Ring|lazuliring.webp",
      "Ruby Ring|rubyring.webp",
      "Sapphire Ring|sapphirering.webp",
      "Topaz Ring|topazring.webp",
      "Amethyst Ring|amethystring.webp",
      "Emerald Ring|emeraldring.webp",
      "Pearl Ring|pearlring.webp",
      "Prismatic Ring|prismaticring.webp",
      "Gold Ring|goldring.webp",
      "Unset Ring|unsetring.webp",
      "Biostatic Ring|breachlordring_tul.webp",
      "Vitalic Ring|breachlordring_xoph.webp",
      "Mnemonic Ring|breachlordring_esh.webp",
      "Kinetic Ring|breachlordring_uulnetol.webp",
      "Oneiric Ring|breachlordring_chayula.webp",
      "Grasping Ring|breachlordring_formless.webp",
      "Dusk Ring|lakering1.webp",
      "Gloam Ring|lakering2.webp",
      "Penumbra Ring|lakering3.webp",
      "Tenebrous Ring|lakering4.webp",
      "Breach Ring|breachring.webp",
      "Refined Breach Ring|breachring.webp"
    ]
  },
  {
    "itemType": "Sceptres",
    "itemClass": "Sceptres",
    "currencySearchName": "Sceptre",
    "imageBaseUrl": "/img/gear/weapons/onehandweapons/scepters/",
    "isCurrency": false,
    "isGear": true,
    "isWeapon": true,
    "baseTypes": [
      "Rattling Sceptre|sceptre01.webp",
      "Stoic Sceptre|sceptre02.webp",
      "Omen Sceptre|sceptre04.webp",
      "Shrine Sceptre|sceptre06a.webp",
      "Wrath Sceptre|sceptre10.webp"
    ]
  },
  {
    "itemType": "Shields",
    "itemClass": "Shields",
    "currencySearchName": "Shield",
    "imageBaseUrl": "/img/gear/offhand/shields/",
    "isCurrency": false,
    "isGear": true,
    "isArmour": true,
    "isShield": true,
    "baseTypes": [
      "Splintered Tower Shield|tower01.webp",
      "Painted Tower Shield|tower02.webp",
      "Braced Tower Shield|tower03.webp",
      "Barricade Tower Shield|tower04.webp",
      "Effigial Tower Shield|tower05.webp",
      "Rampart Tower Shield|tower06.webp",
      "Heraldric Tower Shield|tower07.webp",
      "Stone Tower Shield|tower08.webp",
      "Crucible Tower Shield|tower09.webp",
      "Ancestor Tower Shield|tower10.webp",
      "Hardwood Targe|shield01.webp",
      "Pelage Targe|shield02.webp",
      "Studded Targe|shield03.webp",
      "Crescent Targe|shield04.webp",
      "Chiseled Targe|shield05.webp",
      "Feathered Targe|shield06.webp",
      "Stratified Targe|shield07.webp",
      "Carved Targe|shield08.webp",
      "Blazon Crest Shield|crest01.webp",
      "Sigil Crest Shield|crest02.webp",
      "Emblem Crest Shield|crest03.webp",
      "Jingling Crest Shield|crest04.webp",
      "Sectarian Crest Shield|crest05.webp",
      "Omen Crest Shield|crest06.webp",
      "Wayward Crest Shield|crest07.webp",
      "Seer Crest Shield|crest08.webp",
      "Bulwark Tower Shield|tower06.webp",
      "Noble Tower Shield|tower07.webp",
      "Goldworked Tower Shield|tower08.webp",
      "Polished Targe|shield04.webp",
      "Stone Targe|shield05.webp",
      "Avian Targe|shield06.webp",
      "Dekharan Crest Shield|crest04.webp",
      "Quartered Crest Shield|crest05.webp",
      "Glowering Crest Shield|crest06.webp",
      "Royal Tower Shield|tower03.webp",
      "Fortress Tower Shield|tower06.webp",
      "Vaal Tower Shield|tower08.webp",
      "Tawhoan Tower Shield|tower10.webp",
      "Mammoth Targe|shield02.webp",
      "Baroque Targe|shield04.webp",
      "Soaring Targe|shield06.webp",
      "Golden Targe|shield10.webp",
      "Intricate Crest Shield|crest02.webp",
      "Sekheman Crest Shield|crest04.webp",
      "Vaal Crest Shield|crest06.webp",
      "Blacksteel Crest Shield|crest07.webp"
    ]
  },
  {
    "itemType": "Soul Cores",
    "itemClass": "Augment",
    "currencySearchName": "Soul Core",
    "imageBaseUrl": "/img/currency/soulcores/",
    "isCurrency": true,
    "content": EndgameContent.ChaosTrial,
    "baseTypes": [
      "Hayoxi's Soul Core of Heatproofing|newsoulcoreice.webp",
      "Zalatl's Soul Core of Insulation|newsoulcorelightning.webp",
      "Topotante's Soul Core of Dampening|newsoulcorefire.webp",
      "Atmohua's Soul Core of Retreat|newsoulcoreenergyshield.webp",
      "Quipolatl's Soul Core of Flow|newsoulcoretimecooldown.webp",
      "Tzamoto's Soul Core of Ferocity|newsoulcorerage.webp",
      "Uromoti's Soul Core of Attenuation|newsoulcorecurses2.webp",
      "Opiloti's Soul Core of Assault|newsoulcorefrenzycharge.webp",
      "Guatelitzi's Soul Core of Endurance|newsoulcoreendurancecharge.webp",
      "Xopec's Soul Core of Power|newsoulcorepowercharge.webp",
      "Estazunti's Soul Core of Convalescence|newsoulcoretimeslow.webp",
      "Tacati's Soul Core of Affliction|newsoulcorechaos1.webp",
      "Cholotl's Soul Core of War|newsoulcoreprojectile.webp",
      "Citaqualotl's Soul Core of Foulness|newsoulcorechaos2.webp",
      "Xipocado's Soul Core of Dominion|newsoulcoreminion.webp",
      "Soul Core of Tacati|greatersoulcorechaos.webp",
      "Soul Core of Opiloti|greatersoulcorephysical.webp",
      "Soul Core of Jiquani|greatersoulcorelife.webp",
      "Soul Core of Zalatl|greatersoulcoremana.webp",
      "Soul Core of Citaqualotl|greatersoulcoreelementalresist.webp",
      "Soul Core of Puhuarte|greatersoulcorefire.webp",
      "Soul Core of Tzamoto|greatersoulcorecold.webp",
      "Soul Core of Xopec|greatersoulcorelightning.webp",
      "Soul Core of Azcapa|greatersoulcorewealthrarity.webp",
      "Soul Core of Topotante|greatersoulcoretrielement.webp",
      "Soul Core of Quipolatl|greatersoulcorespeed.webp",
      "Soul Core of Ticaba|greatersoulcorecrit.webp",
      "Soul Core of Atmohua|greatersoulcorestrength.webp",
      "Soul Core of Cholotl|greatersoulcoredex.webp",
      "Soul Core of Zantipi|greatersoulcoreint.webp",
    ]
  },
  {
    "itemType": "Spears",
    "itemClass": "Spears",
    "currencySearchName": "Spear",
    "imageBaseUrl": "/img/gear/weapons/onehandweapons/onehandspears/",
    "isCurrency": false,
    "isGear": true,
    "isWeapon": true,
    "baseTypes": [
      "Hardwood Spear|1hspear01.webp",
      "Ironhead Spear|1hspear02.webp",
      "Hunting Spear|1hspear03.webp",
      "Winged Spear|1hspear04.webp",
      "War Spear|1hspear05.webp",
      "Forked Spear|1hspear06.webp",
      "Barbed Spear|1hspear07.webp",
      "Broad Spear|1hspear08.webp",
      "Crossblade Spear|1hspear09.webp",
      "Seaglass Spear|1hspear10.webp",
      "Helix Spear|1hspear13.webp",
      "Branched Spear|1hspear06.webp",
      "Jagged Spear|1hspear07.webp",
      "Massive Spear|1hspear08.webp",
      "Orichalcum Spear|1hspear02.webp",
      "Soaring Spear|1hspear04.webp",
      "Pronged Spear|1hspear06.webp",
      "Stalking Spear|1hspear03.webp",
      "Flying Spear|1hspear05.webp",
      "Grand Spear|1hspear08.webp",
      "Spiked Spear|1hspear07.webp",
      "Guardian Spear|1hspear09.webp",
      "Akoyan Spear|1hspear10.webp"
    ]
  },
  {
    "itemType": "Staves",
    "itemClass": "Staves",
    "currencySearchName": "Staff",
    "imageBaseUrl": "/img/gear/weapons/twohandweapons/staves/",
    "isCurrency": false,
    "isGear": true,
    "isWeapon": true,
    "baseTypes": [
      "Ashen Staff|staff01.webp",
      "Gelid Staff|staff02.webp",
      "Voltaic Staff|staff03.webp",
      "Pyrophyte Staff|staff05.webp",
      "Chiming Staff|staff06.webp",
      "Reaping Staff|staff08.webp",
      "Roaring Staff|staff10.webp",
      "Paralysing Staff|staff11.webp",
      "Sanctified Staff|staff12.webp"
    ]
  },
  {
    "itemType": "Tablets",
    "itemClass": "Tablet",
    "currencySearchName": "Tablet",
    "imageBaseUrl": "/img/currency/precursortablets/",
    "isCurrency": false,
    "baseTypes": [
      "Breach Tablet|precursortabletbreach.webp",
      "Delirium Tablet|precursortabletdelirium.webp",
      "Ritual Tablet|precursortabletritual.webp",
      "Irradiated Tablet|precursortabletgeneric.webp",
      "Overseer Tablet|precursortabletboss.webp",
      "Abyss Tablet|precursortabletabyss.webp",
      "Temple Tablet|precursortabletincursion.webp"
    ]
  },
  {
    "itemType": "Talismans",
    "itemClass": "Talismans",
    "currencySearchName": "Talisman",
    "imageBaseUrl": "/img/gear/offhand/talismans/",
    "isCurrency": false,
    "isGear": true,
    "isWeapon": true,
    "baseTypes": [
      "Changeling Talisman|changelingtalisman.webp",
      "Nettle Talisman|nettletalisman.webp",
      "Cinderbark Talisman|cinderbarktalisman.webp",
      "Familial Talisman|familialtalisman.webp",
      "Frenzied Talisman|frenziedtalisman.webp",
      "Primal Talisman|primaltalisman.webp",
      "Rabid Talisman|rabidtalisman.webp",
      "Vicious Talisman|vicioustalisman.webp",
      "Voltfang Talisman|voltfangtalisman.webp",
      "Lumbering Talisman|lumberingtalisman.webp",
      "Roaring Talisman|roaringtalisman.webp",
      "Wingbeat Talisman|wingbeattalisman.webp",
      "Condemned Talisman|condemnedtalisman.webp",
      "Howling Talisman|primaltalisman.webp",
      "Fury Talisman|rabidtalisman.webp",
      "Cruel Talisman|vicioustalisman.webp",
      "Spiny Talisman|nettletalisman.webp",
      "Ashbark Talisman|cinderbarktalisman.webp",
      "Fang Talisman|familialtalisman.webp",
      "Fungal Talisman|frenziedtalisman.webp",
      "Alpha Talisman|primaltalisman.webp",
      "Maji Talisman|rabidtalisman.webp",
      "Wildwood Talisman|vicioustalisman.webp",
      "Thunder Talisman|voltfangtalisman.webp",
      "Jade Talisman|lumberingtalisman.webp"
    ]
  },
  {
    "itemType": "Two Hand Maces",
    "itemClass": "Two Hand Maces",
    "currencySearchName": "Two Hand Mace",
    "imageBaseUrl": "/img/gear/weapons/twohandweapons/twohandmaces/",
    "isCurrency": false,
    "isGear": true,
    "isWeapon": true,
    "baseTypes": [
      "Felled Greatclub|2hmace01.webp",
      "Oak Greathammer|2hmace02.webp",
      "Forge Maul|2hmace03.webp",
      "Studded Greatclub|2hmace04.webp",
      "Cultist Greathammer|2hmace05.webp",
      "Temple Maul|2hmace06.webp",
      "Leaden Greathammer|2hmace07.webp",
      "Crumbling Maul|2hmace08.webp",
      "Pointed Maul|2hmace09.webp",
      "Totemic Greatclub|2hmace10.webp",
      "Solemn Maul|2hmace06.webp",
      "Heavy Greathammer|2hmace07.webp",
      "Disintegrating Maul|2hmace08.webp",
      "Anvil Maul|2hmace03.webp",
      "Sacred Maul|2hmace06.webp",
      "Ironwood Greathammer|2hmace02.webp",
      "Fanatic Greathammer|2hmace05.webp",
      "Ruination Maul|2hmace08.webp",
      "Massive Greathammer|2hmace07.webp",
      "Tawhoan Greatclub|2hmace10.webp"
    ]
  },
  {
    "itemType": "Wands",
    "itemClass": "Wands",
    "currencySearchName": "Wand",
    "imageBaseUrl": "/img/gear/weapons/onehandweapons/wands/",
    "isCurrency": false,
    "isGear": true,
    "isWeapon": true,
    "baseTypes": [
      "Withered Wand|wand01.webp",
      "Bone Wand|wand02.webp",
      "Attuned Wand|wand03.webp",
      "Siphoning Wand|wand04.webp",
      "Volatile Wand|wand05.webp",
      "Galvanic Wand|wand06.webp",
      "Dueling Wand|wand13.webp"
    ]
  },
  {
    "itemType": "Waystones",
    "itemClass": "Waystones",
    "currencySearchName": "Waystone",
    "imageBaseUrl": "/img/gear/maps/endgamemaps/",
    "isCurrency": false,
    "baseTypes": [
      "Waystone (Tier 1)|endgamemap1.webp",
      "Waystone (Tier 2)|endgamemap2.webp",
      "Waystone (Tier 3)|endgamemap3.webp",
      "Waystone (Tier 4)|endgamemap4.webp",
      "Waystone (Tier 5)|endgamemap5.webp",
      "Waystone (Tier 6)|endgamemap6.webp",
      "Waystone (Tier 7)|endgamemap7.webp",
      "Waystone (Tier 8)|endgamemap8.webp",
      "Waystone (Tier 9)|endgamemap9.webp",
      "Waystone (Tier 10)|endgamemap10.webp",
      "Waystone (Tier 11)|endgamemap11.webp",
      "Waystone (Tier 12)|endgamemap12.webp",
      "Waystone (Tier 13)|endgamemap13.webp",
      "Waystone (Tier 14)|endgamemap14.webp",
      "Waystone (Tier 15)|endgamemap15.webp",
      "Waystone (Tier 16)|endgamemap16.webp"
    ]
  }
]
